import PropTypes from "prop-types";
import React from "react";
import ExpandableParagraph from "components/componentLibrary/content/ExpandableParagraph";
import { NATURAL_LIGHT, FLOOR_MATERIAL } from "util/constants";

import styles from "./style.module.scss";

const AboutTheListing = ({
  description,
  naturalLight,
  hasWetPantry,
  floorMaterial,
  conferenceRooms,
  hasExposedCeiling,
  hasPrivateBathroom,
}) => (
  <div className={styles.flexColumnLayout}>
    <p className={`${styles.aboutTheOffice} bodyEmphasis`}>About The Office</p>

    {description && (
      <div className={styles.flexColumnLayout}>
        <p className={styles.subHeader}>Office description</p>
        <div>
          <ExpandableParagraph content={description} />
        </div>
      </div>
    )}

    {(naturalLight ||
      hasWetPantry ||
      floorMaterial ||
      conferenceRooms ||
      hasExposedCeiling ||
      hasPrivateBathroom) && (
      <div className={styles.flexColumnLayout}>
        <p className={styles.subHeader}>Amenities</p>

        <div className={styles.amenitiesList}>
          {naturalLight && naturalLight !== "NONE" && naturalLight !== "POOR" && (
            <div className={styles.amenity}>
              <i
                className={`${
                  styles.amenityIcon
                } icon icon-lighting-${naturalLight.toLowerCase()}`}
              />
              <body>{`${NATURAL_LIGHT[naturalLight]} Natural Lighting`}</body>
            </div>
          )}

          {hasWetPantry && (
            <div className={styles.amenity}>
              <div className={styles.amenityIcon}>
                <i className="icon icon-wet-pantry" />
              </div>
              <body>Wet Pantry</body>
            </div>
          )}

          {floorMaterial && floorMaterial !== "UNKNOWN" && (
            <div className={styles.amenity}>
              <div className={styles.amenityIcon}>
                <i
                  className={`icon icon-floor-${floorMaterial.toLowerCase()}`}
                />
              </div>
              <body>{`${FLOOR_MATERIAL[floorMaterial]} Flooring`}</body>
            </div>
          )}

          {hasPrivateBathroom && (
            <div className={styles.amenity}>
              <div className={styles.amenityIcon}>
                <i className="icon icon-bathroom-private" />
              </div>
              <body>Private Bathroom</body>
            </div>
          )}

          {conferenceRooms && (
            <div className={styles.amenity}>
              <div className={styles.amenityIcon}>
                <i className="icon icon-conference-rooms" />
              </div>
              <body>
                {conferenceRooms === 1
                  ? "1 Conference Room"
                  : `${conferenceRooms} Conference Rooms`}
              </body>
            </div>
          )}

          {hasExposedCeiling && (
            <div className={styles.amenity}>
              <div className={styles.amenityIcon}>
                <i className="icon-exposed-ceiling" />
              </div>
              <body>Exposed Ceiling</body>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
);

AboutTheListing.propTypes = {
  hasWetPantry: PropTypes.bool,
  description: PropTypes.string,
  conferenceRooms: PropTypes.number,
  hasExposedCeiling: PropTypes.bool,
  hasPrivateBathroom: PropTypes.bool,
  floorMaterial: PropTypes.oneOf([
    "CONCRETE",
    "HARDWOOD",
    "CARPET",
    "UNKNOWN",
    null,
  ]),
  naturalLight: PropTypes.oneOf([
    "NONE",
    "POOR",
    "GOOD",
    "VERY_GOOD",
    "EXCELLENT",
    null,
  ]),
};

AboutTheListing.defaultProps = {
  description: null,
  naturalLight: null,
  conferenceRooms: 0,
  hasWetPantry: false,
  floorMaterial: null,
  hasExposedCeiling: false,
  hasPrivateBathroom: false,
};

export default AboutTheListing;
